package ai.wagemix.web.screens.share

import ai.wagemix.logic.share.WMSharePreviewState
import ai.wagemix.web.components.WMButton
import ai.wagemix.web.components.WMButtonKind
import ai.wagemix.web.components.WMButtonSize
import ai.wagemix.web.components.WMIconGlyph
import ai.wagemix.web.components.WMNotice
import ai.wagemix.web.components.WMNoticeKind
import ai.wagemix.web.screens.WMWebStrings
import ai.wagemix.web.theme.WMBodySmallTextStyle
import ai.wagemix.web.theme.WMCardCornerVar
import ai.wagemix.web.theme.WMTightGapVar
import androidx.compose.runtime.Composable
import com.fsryan.foundation.web.theme.fs
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette

/**
 * A shared link's preview image: the image when there is one, "rendering" while the API works on it, and, when it
 * failed or stalled, a notice with Regenerate. An image from an earlier render stays visible beside the notice.
 */
@Composable
fun WMSharePreviewImage(
    strings: WMWebStrings,
    state: WMSharePreviewState?,
    imageUrl: String?,
    modifier: Modifier = Modifier,
    onRegenerate: () -> Unit
) {
    val sh = strings.share
    val colors = ColorMode.current.toPalette().fs
    Column(modifier = Modifier.fillMaxWidth().gap(WMTightGapVar.value()).then(modifier)) {
        if (imageUrl != null) {
            val imageModifier = Modifier.fillMaxWidth().borderRadius(WMCardCornerVar.value())
            Image(imageUrl, alt = sh.previewImage, modifier = imageModifier)
        }
        when (state) {
            WMSharePreviewState.Failed -> WMNotice(
                title = sh.previewFailedTitle,
                kind = WMNoticeKind.Warning,
                message = sh.previewFailedMessage,
            ) {
                WMButton(
                    sh.regeneratePreview,
                    kind = WMButtonKind.Secondary,
                    size = WMButtonSize.Sm,
                    leadingIcon = WMIconGlyph.RefreshCw,
                    onClick = onRegenerate
                )
            }
            WMSharePreviewState.Ready -> Unit
            WMSharePreviewState.Generating, null -> if (imageUrl == null) {
                SpanText(sh.previewLoading, WMBodySmallTextStyle.toModifier().color(colors.onSurfaceVariant))
            }
        }
    }
}
